import { swRequest } from "./sw-request.js";

export const getOrganization = (organizationId) =>
  swRequest({
    path: "/api/organizations/get",
    params: { organizationId },
  });
